import React, { useEffect, useState, useRef, memo, useContext } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DragHandle } from "./DragHandle";
import styled from "styled-components";
import { TableRow, TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import { Button as AntdButton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CachedIcon from "@mui/icons-material/Cached";
import CommitIcon from "@mui/icons-material/Commit";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import PlusMinQty from "../../utilities/PlusMinQty";
import PlusMinStrike from "../../utilities/PlusMinStrike";
import DropdownSelect from "../../../ui-components/DropdownSelect";
import {
  generateUniqueId,
  calculateSLTP,
  calculatePrice,
} from "../../../util/helper";
import { Tooltip } from "antd";
import { isString } from "antd/es/button";
import moment from "moment";
import { BadgePercent, Copy, IndianRupee, Play, Receipt, RefreshCcw, X, Bolt } from "lucide-react";
import InfoIcon from "@mui/icons-material/Info";
import LegRiskModal from "./LegRiskModal";
const DraggingRow = styled.td`
  background: rgba(127, 207, 250, 0.3);
`;

const TableData = styled.td`
  background: white;
  &:first-of-type {
    min-width: 20ch;
  }
`;
const useStyles = makeStyles((theme) => ({
  headingCol: {
    padding: "4px",
    fontFamily: "poppins",
    color: "#000",
  },
}));
const initial = {
  lot: 0,
  price: 0,
  stopLossPrice: 0,
  targetPrice: 0,
  id: "",
  isUpdated: false,
  quantity: 0,
};
const defSLTP = ["Price", "PNL"];

export const DraggableTableRow = ({
  info,
  windowScreen,
  inputValues,
  row,
  lp,
  index,
  handleOrderExit,
  handleOrderexecute,
  handleOrderRefresh,
  handleOrderCopy,
  updateFieldValue,
  handlessltpPrice,
  changeBuySell,
  strikeChange,
  cellTypeClick,
  expiryOptions,
  handleExpiryChange,
  orderTypeClick,
  handleFieldcClick,
  handleSltpBasisChange,
  handleProductChange,
  handleShowCharges
}) => {
  const {
    attributes,
    listeners,
    transform,
    transition,
    setNodeRef,
    isDragging
  } = useSortable({
    id: row.original.id
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  const basket = useSelector((state) => state.basket.data);
  const [isError, seterror] = useState("");
  const [errorMessages, setErrorMessages] = useState({
    stopLoss: "",
    target: "",
    trailSL: ""
  });

  const [formData, setFormData] = useState(initial);
  const [editFieldsName, seteditFieldsName] = useState("");
  const [slValueType, setSlValueType] = useState(0);
  const [tpValueType, setTpValueType] = useState(0);
  const [trValueType, setTrValueType] = useState(2);
  const formRefSL = useRef();
  const formRefTP = useRef();
  const [legRiskModalShow, setLegRiskModalShow] = useState(false);
  const defProduct = ['NRML', 'MIS'];
  const lastInputValues = useRef(null);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   document.body.addEventListener('click', (e) => {
  //     e.preventDefault()
  //     if (formRefSL.current && formRefTP.current && !e.composedPath().includes(formRefSL.current) && !e.composedPath().includes(formRefTP.current) ) {
  //       seteditFieldsName("");
  //     }
  //   });
  // }, []);

  useEffect(() => {
    if (
      row &&
      row.original &&
      Object.keys(row.original)
    ) {

      const resolvedSlValueType = row.original.stopLossValueType ?? 0;
      const resolvedTpValueType = row.original.targetValueType ?? 0;
      const resolvedTrValueType = row.original.trailSLValueType ?? 0;

      setSlValueType(resolvedSlValueType);
      setTpValueType(resolvedTpValueType);
      setTrValueType(resolvedTrValueType);

      const calculatePriceLP = calculatePrice(
        lp,
        row.original.marketProtect || 0,
        row.original.transactionType,
        row.original.orderType,
        row.original.marketBuffer || 0
      );

      const value = {
        ...formData,
        sltpType: row.original.sltpType || "Price",
        stopLossPrice: row.original.stopLossPrice ?? null,
        targetPrice: row.original.targetPrice ?? null,
        trailSLReference: row.original.trailSLReference ?? null,
        trailSLStep: row.original.trailSLStep ?? null,
        id: row.original.id,
        price: row.original.price || (row.original.orderType !== "MARKET" && row.original.orderType !== "Limit at LTP" ? calculatePriceLP?.price : null),
        quantity: row.original.quantity / row.original.lotSize,
        stopLossValueType: resolvedSlValueType,
        targetValueType: resolvedTpValueType,
        trailSLValueType: resolvedTrValueType,
        profitLockAt: row.original.profitLockAt ?? null,
        profitLockSl: row.original.profitLockSl ?? null,
        profitLockTrailReference: row.original.profitLockTrailReference ?? null,
        profitLockTrailStep: row.original.profitLockTrailStep ?? null,
        profitLockTrailValueType: row.original.profitLockTrailValueType ?? 2,
      };

      setFormData(value);
    }
  }, [row, lp]);

  useEffect(() => {
    setErrorMessages({ stopLoss: "", target: "", trailSL: "" });
    seterror("");

    if (formData.sltpType === "PNL") {
      setSlValueType(0);
      setTpValueType(0);
      const updatedFormData = {
        ...formData,
        stopLossValueType: 0,
        targetValueType: 0
      };
      setFormData(updatedFormData);
      handlessltpPrice(updatedFormData);
    }
  }, [formData.sltpType]);

  const calculateActualPrice = (value, valueType, basePrice, isStopLoss = false) => {
    if (value === null || value === undefined || value === '' || value === 0) return null;
    const val = parseFloat(value);
    if (isNaN(val)) return null;

    const base = parseFloat(basePrice);
    if (isNaN(base)) return null;

    const isLongPosition = row.original.transactionType === "BUY";
    let result;

    switch (valueType) {
      case 0:
        result = val;
        break;
      case 1:
        if (formData.sltpType === "Price") {
          if (isStopLoss) {
            result = isLongPosition ? base - (base * val / 100) : base + (base * val / 100);
          } else {
            result = isLongPosition ? base + (base * val / 100) : base - (base * val / 100);
          }
        } else {
          result = base + (base * val / 100);
        }
        break;
      case 2:
        if (formData.sltpType === "Price") {
          if (isStopLoss) {
            result = isLongPosition ? base - val : base + val;
          } else {
            result = isLongPosition ? base + val : base - val;
          }
        } else if (formData.sltpType === "PNL") {
          const currentPNL = parseFloat(row.original?.unrealizedPNL || 0);
          result = isStopLoss ? currentPNL - val : currentPNL + val;
        } else {
          result = base + val;
        }
        break;
      default:
        result = val;
    }

    return result;
  };

  const getBasePrice = () => {
    const basisIsPNL = formData.sltpType === "PNL";
    if (basisIsPNL) {
      return 0;
    } else {
      return lp;
    }
  };

  const validateTrailSL = (ref, step) => {
    const refVal = ref !== null && ref !== undefined && ref !== '' ? parseFloat(ref) : null;
    const stepVal = step !== null && step !== undefined && step !== '' ? parseFloat(step) : null;

    if ((refVal !== null && stepVal === null) || (refVal === null && stepVal !== null)) {
      setErrorMessages((prev) => ({ ...prev, trailSL: "Both fields required" }));
      return false;
    }

    if (refVal !== null && stepVal !== null) {
      if (refVal < 0 || stepVal < 0) {
        setErrorMessages((prev) => ({ ...prev, trailSL: "Must be non-negative" }));
        return false;
      }
    }

    setErrorMessages((prev) => ({ ...prev, trailSL: "" }));
    return true;
  };

  const handleFieldChange = (val, name, row, lp) => {
    if (formData.sltpType === "Price") {
      if (name === "stopLossPrice" && row?.original?.transactionType === "BUY" && slValueType === 1) {
        const parsedVal = parseFloat(val);
        if (!isNaN(parsedVal) && parsedVal > 100) {
          val = 100;
        }
      }
      if (name === "targetPrice" && row?.original?.transactionType === "SELL" && tpValueType === 1) {
        const parsedVal = parseFloat(val);
        if (!isNaN(parsedVal) && parsedVal > 100) {
          val = 100;
        }
      }
    }

    const defvalue = {
      ...formData,
      [name]: val > 0 ? parseFloat(val) : val,
    };

    if (name === "stopLossPrice" && (!val || val === 0 || val === null)) {
      defvalue.trailSLReference = null;
      defvalue.trailSLStep = null;
      setErrorMessages((prev) => ({ ...prev, trailSL: "" }));
    }

    if (name === "trailSLReference" || name === "trailSLStep") {
      const newRef = name === "trailSLReference" ? defvalue.trailSLReference : formData.trailSLReference;
      const newStep = name === "trailSLStep" ? defvalue.trailSLStep : formData.trailSLStep;
      validateTrailSL(newRef, newStep);
    }

    if (name === "stopLossPrice") {
      isValidsltp("sl", parseFloat(val), lp, row);
    }

    if (name === "targetPrice") {
      isValidsltp("tp", parseFloat(val), lp, row);
    }

    setFormData(defvalue);

    if (name === "quantity" || name === "price") {
      handleFieldcClick(row, val, name);
    } else {
      handlessltpPrice(defvalue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      seteditFieldsName("");
      //  updateFieldValue(e.target.name, formData, index, row);
    }
  };


  const editFields = (name, index, row) => {
    if (
      name === "strike" ||
      name === "price" ||
      name === "quantity" ||
      name === "stopLossPrice" ||
      name === "targetPrice"
    ) {
      seteditFieldsName(name + "_" + index);

      const value = {
        ...formData,
        [name + "_" + index]:
          name === "price"
            ? parseFloat(row.price)
            : name === "quantity"
              ? row.quantity / row.lotSize
              : 0,
      };
      setFormData(value);
    } else {
      //seteditFieldsName("");
    }
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the referenced element
    // if (ref.current && !ref.current.contains(event.target)) {
    //   seteditFieldsName("");
    // }
  };


  const handleCellHover = (name, index, row) => {
    if (
      name === "price" ||
      name === "quantity" ||
      name === "stopLossPrice" ||
      name === "targetPrice"
    ) {
      seteditFieldsName(name + "_" + index);
      const value = {
        ...formData,
        [name + "_" + index]:
          name === "price"
            ? parseFloat(row.price)
            : name === "quantity"
              ? row.quantity / row.lotSize
              : 0,
      };
      setFormData(value);
    } else {
      //seteditFieldsName("");
    }
  };

  const isValidsltp = (type, val, lp, rowData) => {
    const setMsg = (ok, customMsg = null) => {
      if (type === "sl") {
        const msg = customMsg || (formData.sltpType === "PNL"
          ? "Stop Loss should be below current PNL"
          : (rowData.transactionType === "BUY"
            ? "Stop Loss should be below current price"
            : "Stop Loss should be above current price"));
        setErrorMessages(prev => ({ ...prev, stopLoss: ok ? "" : msg }));
      } else {
        const msg = customMsg || (formData.sltpType === "PNL"
          ? "Target should be above current PNL"
          : (rowData.transactionType === "BUY"
            ? "Target should be above current price"
            : "Target should be below current price"));
        setErrorMessages(prev => ({ ...prev, target: ok ? "" : msg }));
      }
      seterror(ok ? "" : type);
    };

    if (val === null || val === undefined || val === '' || val === 0) {
      setMsg(true);
      return true;
    }

    const parsedVal = parseFloat(val);
    if (Number.isNaN(parsedVal)) {
      setMsg(true);
      return true;
    }

    const actualPrice = type === "sl"
      ? calculateActualPrice(parsedVal, slValueType, getBasePrice(), true)
      : calculateActualPrice(parsedVal, tpValueType, getBasePrice(), false);

    if (actualPrice === null) {
      setMsg(true);
      return true;
    }

    if (formData.sltpType === "Price") {
      if (actualPrice < 0) {
        setMsg(false, type === "sl" ? "Stop Loss must be positive" : "Target must be positive");
        return false;
      }
    }

    if (formData.sltpType === "PNL") {
      const valueType = type === "sl" ? slValueType : tpValueType;
      if (valueType === 2 && val < 0) {
        setMsg(false, type === "sl" ? "Stop Loss cannot be negative" : "Target cannot be negative");
        return false;
      }

      const pnl = parseFloat(rowData.original?.unrealizedPNL || 0);
      if (Number.isNaN(pnl)) {
        setMsg(true);
        return true;
      }

      if (type === "sl") {
        const ok = actualPrice < pnl;
        setMsg(ok);
        return ok;
      } else {
        const ok = actualPrice > pnl;
        setMsg(ok);
        return ok;
      }
    }

    // Price-based validation
    const currentLtp = parseFloat(lp || 0);

    if (Number.isNaN(currentLtp) || currentLtp === 0) {
      setMsg(true);
      return true;
    }

    if (type === "sl") {
      if (rowData.transactionType === "BUY") {
        const ok = actualPrice < currentLtp;
        setMsg(ok);
        return ok;
      } else {
        const ok = actualPrice > currentLtp;
        setMsg(ok);
        return ok;
      }
    } else {
      if (rowData.transactionType === "BUY") {
        const ok = actualPrice > currentLtp;
        setMsg(ok);
        return ok;
      } else {
        const ok = actualPrice < currentLtp;
        setMsg(ok);
        return ok;
      }
    }
  };

  useEffect(() => {
    if (!formData || Object.keys(formData).length === 0 || !row) return;

    if (formData.stopLossPrice !== null && formData.stopLossPrice !== undefined && formData.stopLossPrice !== '' && formData.stopLossPrice !== 0) {
      isValidsltp("sl", parseFloat(formData.stopLossPrice), lp, row.original);
    }

    if (formData.targetPrice !== null && formData.targetPrice !== undefined && formData.targetPrice !== '' && formData.targetPrice !== 0) {
      isValidsltp("tp", parseFloat(formData.targetPrice), lp, row.original);
    }

    validateTrailSL(formData.trailSLReference, formData.trailSLStep);
  }, [formData, slValueType, tpValueType, lp, row]);

  const renderTypeLabel = (vt) => (vt === 0 ? "₹" : vt === 1 ? "%" : "Pts");
  const renderTrailTypeLabel = (vt) => (vt === 1 ? "%" : "Pts");
  const renderPNLLabel = () => "₹₹";
  const renderPNLSLTPLabel = (vt) => (vt === 0 ? "₹₹" : "Pts");
  const cycleWithin = (current, allowed) => {
    const idx = allowed.indexOf(current);
    const nextIdx = (idx + 1) % allowed.length;
    return allowed[nextIdx];
  };

  const shouldHideRms = inputValues?.applyRmsToSellOnly && row.original.transactionType !== "SELL";


  const { key: rowKey, ...rowProps } = row.getRowProps();

  return (
    <TableRow key={rowKey} ref={setNodeRef} style={style} {...rowProps}>
      {isDragging ? (
        <DraggingRow colSpan={row.cells.length}>&nbsp;</DraggingRow>
      ) : (
        row.cells.map((cell, i) => {
          const { key: cellKey, ...cellProps } = cell.getCellProps();
          const columnId = cell.column.id;
          if (i === 0) {
            return (
              <TableCell 
                key={cellKey}
                style={{ width: "24px" }} 
                className="dataCell" 
                {...cellProps}
              >
                  <DragHandle isDragging={isDragging} {...attributes} {...listeners} />
              </TableCell>
            );
          }
          return (
            <TableCell
              key={cellKey}
              {...cellProps}
              align={cell.column.align}
              className={"order-window-body dataCell"}
              style={{
                minWidth: columnId === "symbol" ? "120px" : columnId === "price" ? "180px" : columnId === "orderType" ? "160px" : columnId === "transactionType" ? undefined : "100px",
                textAlign: columnId === "ltp" ? "right" : undefined,
                display: columnId === "price" ? "flex" : undefined,
                justifyContent: columnId === "price" ? "center" : undefined,
              }}
            >
              {columnId === "action" ? (
                <div className="d-flex gap-1 me-3 ms-3">
                  <Tooltip
                    placement="top"
                    title="Refresh"
                    overlayStyle={{ position: 'fixed' }}
                  >
                    <AntdButton
                      className="edit-strat-btn"
                      size="small"
                      icon={<RefreshCcw size={14} />}
                      onClick={() => handleOrderRefresh(row.original, index)}
                    />
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title="Copy"
                    overlayStyle={{ position: 'fixed' }}
                  >
                    <AntdButton
                      className="copy-webhook-btn"
                      size="small"
                      icon={<Copy size={14} />}
                      onClick={() => handleOrderCopy(row.original, index)}
                    />
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title="Execute Order"
                    overlayStyle={{ position: 'fixed' }}
                  >
                    <AntdButton
                      className="manual-execution-btn"
                      size="small"
                      icon={<Play size={14} />}
                      onClick={() => handleOrderexecute(row.original, index)}
                    />
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title="Exit Order"
                    overlayStyle={{ position: 'fixed' }}
                  >
                    <AntdButton
                      className="delete-btn"
                      size="small"
                      icon={<X size={14} />}
                      onClick={() => handleOrderExit(row.original, index)}
                    />
                  </Tooltip>
                </div>
              ) : columnId === "ltp" ? (
                <>{lp.toFixed(2)}</>
              ) : columnId === "transactionType" ? (
                <Button
                  style={{height: '26px', fontSize: '12px'}}
                  size="sm"
                  type="button"
                  onClick={() => changeBuySell(row.original)}
                  className={row.original.transactionType === "BUY" ? "qt-buy-btn" : "qt-sell-btn"}
                >
                  {cell.render("Cell")}
                </Button>
              ) : columnId === "quantity" ? (
                <div ref={formRefSL}>
                  <Form.Group className="form-group">
                    <Form.Label>Lot</Form.Label>{" "}
                    <Form.Label className="custom-label">
                      {" "}

                    </Form.Label>
                    <PlusMinQty
                      qtyClick={(qty, value) => {
                        handleFieldChange(qty, "quantity", row.original, lp);
                      }}
                      filterValue={formData.quantity}
                      name={"quantity"}
                      min={1}
                      step={1}
                      max={null}
                    />
                    <span style={{ whiteSpace: "nowrap", fontSize: "10px", paddingInline: "8px" }}>
                      {"Qty: "}
                      {info.lotSize ? info.lotSize * formData.quantity : 0}
                    </span>
                  </Form.Group>
                </div>
              ) : columnId === "price" ? (
                  <div ref={formRefSL} className="d-flex align-items-center gap-1">
                   {(row?.original?.orderType === "LIMIT" || row?.original?.orderType === "SL" || row?.original?.orderType === "Limit with buffer"  ) ? (
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty.toString(), "price", row.original, lp);
                        }}
                        filterValue={formData.price}
                        name={"price"}
                        handleKeyDown={handleKeyDown}
                      />
                    ) : (
                      <span>{row?.original?.orderType === "MARKET" || row?.original?.orderType === "SL-M" || row?.original?.orderType === "Mkt protect" || row?.original?.orderType === "Limit at ltp" ? "-" : ""}</span>
                    )}
                    {row?.original?.triggerPrice ? (
                      <p>
                        <span>/</span>
                        <span className="ms-1">{row.original.triggerPrice}</span>
                        <span style={{ fontSize: "10px" }}>Trg</span>
                      </p>
                    ) : null}
                  </div>
              ) : columnId === "legRiskSettings" ? (
                <div className="d-flex align-items-center justify-content-center">
                      <Bolt
                        size={20}
                        strokeWidth={1.5}
                        className="cursor-pointer"
                        onClick={() => setLegRiskModalShow(true)}
                      />
                      <LegRiskModal
                        show={legRiskModalShow}
                        setShow={setLegRiskModalShow}
                        row={row.original}
                        lp={lp}
                        info={info}
                        handlessltpPrice={handlessltpPrice}
                      />
                </div>
              ) : columnId === "margin" ? (
                !cell.render("Cell") ? (
                  <Spinner
                    className="small-spinner"
                    animation="border"
                    variant="primary"
                  />
                ) : (
                  cell.render("Cell")
                )
              ) : columnId === "strike" ? (
                <PlusMinStrike
                  strikeClick={(type) => {
                    strikeChange(type, row.original);
                  }}
                  value={row.original.strike}
                />
              ) : columnId === "cellType" ? (
                <span className={"cellType"} onClick={() => cellTypeClick(row.original)}>
                  {cell.render("Cell")}{" "}
                </span>
              ) : columnId === "orderType" ? (
                <span className={"orderType"} onClick={() => orderTypeClick(row.original)}>
                  {(() => {
                    const oType = row.original.orderType;
                    const mProtect = row.original.marketProtect ?? 0;
                    const mBuffer = row.original.marketBuffer ?? 0;
                    if (oType === "Mkt protect") {
                      if(mProtect > 0){
                      return `Mkt protect(${mProtect}%)`;
                      }else{
                        return 'MARKET';
                      }
                    }
                    if (oType === "Limit with buffer") return `Limit with buffer(${mBuffer}%)`;
                    if (oType === "SL") return "SL-L";
                    return cell.render("Cell");
                  })()}{" "}
                </span>
              ) : columnId === "expiry" ? (
                <DropdownSelect
                  options={expiryOptions.map((item) =>
                    moment(item).format("DD-MMM-YY")
                  )}
                  width={105}
                  height={"26px"}
                  onChange={(e) => handleExpiryChange(row.original, e)}
                  size="middle"
                  value={
                    moment(row.original.expiry).format("DD-MMM-YY") ||
                    moment(expiryOptions[0]).format("DD-MMM-YY")
                  }
                />
              ) : columnId === "product" ? (
                <span className="cellType" onClick={() => handleProductChange(row, row.original.product === "NRML" ? "MIS" : "NRML")}>
                  {row.original.product}
                </span>
              ) : columnId === "charges" ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <AntdButton
                        size="small"
                        icon={<IndianRupee size={14} />}
                        onClick={() => handleShowCharges(row.original.charges)}
                    />
                  </div>
              ) : (
                <span className={columnId?.toString()}>{cell.render("Cell")} </span>
              )}
            </TableCell>
          );
        })
      )}
    </TableRow>
  );
};
